<template>
  <div>
    <router-view v-if="client && client.id" />
    <v-row no-gutters justify="center" align="center" style="min-height: 100px;" v-else>
      <v-progress-linear
        color="primary"
        indeterminate
        rounded
        height="6"
        class="absolute-progress"
      ></v-progress-linear>
    </v-row>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: `SettingsClient`,
  computed: {
    ...mapState(`model/client`, {
      client: `currentAdminClient`,
    }),
  },
  beforeMount() {
    this.$store.commit(`model/client/SET_CURRENT_ADMIN_CLIENT`, {});
    this.$store.dispatch(`model/client/fetchCurrentAdminClient`, this.$route.params.clientId);
  },
};
</script>

<style lang="scss">
</style>
